import { useRegister } from "./RegisterContext";
import { useTranslation } from "react-i18next";



export default function MediaVerification() {
    const {
        details,
        verificationData,
        setVerificationData,
    } = useRegister();

    const { t } = useTranslation();

    const type = details.type;
    const status = details.status;

    const isJournalist =
        status === "mediaForm.journalist";

    const isProfessional =
        type === "mediaForm.professional";

    const isCompany =
        type === "mediaForm.company";

    const handleFile = (e) => {
        const { name, files } = e.target;

        setVerificationData((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    };

    const getMessage = () => {

        if (isCompany) {
            return {
                title: t("mediaVerification.legalTitle"),
                text: t("mediaVerification.companyText")
            };
        }

        if (isJournalist) {
            return {
                title: t("mediaVerification.mediaTitle"),
                text: t("mediaVerification.journalistText")
            };
        }

        if (isProfessional) {
            return {
                title: t("mediaVerification.mediaTitle"),
                text: t("mediaVerification.professionalText")
            };
        }

        return {
            title: t("mediaVerification.verification"),
            text: ""
        };
    };

    const message = getMessage();

    return (
        <div className="verification-wrapper">

            <VerificationInfo
                title={message.title}
                text={message.text}
            />

            <div className="verification-content">

                {isCompany && (
                    <UploadBox
                        label={t("mediaVerification.tradeRegister")}
                        name="media_rc"
                        file={verificationData.media_rc}
                        onChange={handleFile}
                    />
                )}

                {isProfessional && (
                    <>
                        <UploadBox
                            label={t("mediaVerification.identity")}
                            name="own_id"
                            file={verificationData.own_id}
                            onChange={handleFile}
                        />

                        {isJournalist ? (
                            <UploadBox
                                label={t("mediaVerification.pressCard")}
                                name="media_press_card"
                                file={
                                    verificationData.media_press_card
                                }
                                onChange={handleFile}
                            />
                        ) : (
                            <UploadBox
                                label={t("mediaVerification.mediaProof")}
                                name="media_proof"
                                file={verificationData.media_proof}
                                onChange={handleFile}
                            />
                        )}
                    </>
                )}

            </div>

            <PrivacyNotice />

        </div>
    );
}

function VerificationInfo({ title, text }) {

    const { t } = useTranslation();

    return (
        <div className="verification-info-card">
            <div className="verification-badge">
                ✓ {t("mediaVerification.carrerupVerification")}
            </div>

            <h3>{title}</h3>
            <p>{text}</p>
        </div>
    );
}

function PrivacyNotice() {

    const { t } = useTranslation();

    return (
        <div className="verification-privacy">
            🔒 {t("mediaVerification.privacy")}
        </div>
    );
}

function UploadBox({ label, name, file, onChange }) {
    return (
        <div className="input-wrapper full-width">
            <label className="pdf-upload-label">
                {label}

                <input
                    required
                    type="file"
                    name={name}
                    accept=".pdf,image/*"
                    hidden
                    onChange={onChange}
                />
            </label>

            {file && (
                <div className="pdf-selected">
                    📄 {file.name}
                </div>
            )}
        </div>
    );
}
